import React from "react";

import useNavigation from "../../hooks/useNavigation";

import SchoolMobileViewHeader from "../components/SchoolMobileViewHeader";
import SchoolMobileListItem from "../components/SchoolMobileListItem";

const SchoolMobileSectionView = ({ view }) => {
  const { closeMobileMenu } = useNavigation();

  const { title, data } = view;

  return (
    <div className="school-mobile-section-view">

      <SchoolMobileViewHeader title={title} />

      {data.links.map((link) => (
        <SchoolMobileListItem
          key={link.id}
          label={link.label}
          icon={link.icon}
          to={link.to}
          external={link.external}
          onClick={closeMobileMenu}
        />
      ))}

    </div>
  );
};

export default SchoolMobileSectionView;